module.exports = __webpack_public_path__ + "static/media/stock.283e5ecd.svg";